export const getStaffFilterPreset = (dataDealer: {
  id?: number | string;
  dealerName?: string;
}) => {
  return {
    name: "",
    middleName: "",
    surname: "",
    lastEditFrom: "",
    creationTo: "",
    lastEditTo: "",
    creationFrom: "",
    workPhone: "",
    email: "",
    status: null,
    DealerId: dataDealer.id
      ? [
          {
            label: dataDealer.dealerName || String(dataDealer.id),
            value: dataDealer.id,
          },
        ]
      : [],
    namePosition: [],
    ladaAcademiaIds: [],
    emailVerification: {
      label: "Ничего не выбрано",
      value: null,
    },
  };
};
